// extracted by mini-css-extract-plugin
export default {"formIcon":"Icons__formIcon--2LD","hideIcon":"Icons__hideIcon--2mi"};